const isMobile = function(){
    return window.innerWidth <= 960;
}

export default isMobile;